import { CircleNotch } from "@phosphor-icons/react";

export const Spinner = ({ label = "Loading" }) => (
  <div className="flex min-h-[50vh] flex-col items-center justify-center gap-3" data-testid="loading-spinner">
    <CircleNotch size={26} className="animate-spin text-navy-800" />
    <p className="text-sm text-muted-foreground">{label}…</p>
  </div>
);
